import gql from "graphql-tag";

export default gql`
  fragment ReactableFields on Reactable {
    viewerCanReact
    reactionGroups {
      content
      totalReactions
      viewerHasReacted
    }
  }
`;
